/**
 * Returns the dot product of two 1-D arrays
 */
export function dotProduct(a: number[], b: number[]): number {
    let prod = 0;
    for (let i = 0; i < a.length; i++) {
        prod += a[i] * b[i];
    }
    return prod;
}

/**
 * Returns the magnitude of a vector, where the vector is represented as an array
 */
export function magnitude(a: number[]): number {
    let sum = 0;
    for (let i = 0; i < a.length; i++) {
        sum += a[i] * a[i];
    }
    return Math.sqrt(sum);
}

/**
 * Returns the cosine similarity between two vectors
 *
 * https://en.wikipedia.org/wiki/Cosine_similarity
 */
export function cosine_similarity(a: number[], b: number[]): number {
    return dotProduct(a, b) / (magnitude(a) * magnitude(b));
}
